<template>
  <home-layout>
    <div class="page-bn"></div>
    <div class="container">
      <guide-list v-bind:guideList="this.$store.state.guideList" v-if="this.$store.state.guideList.length > 0"></guide-list>
      <scene-list v-bind:sceneList="this.$store.state.sceneList" v-if="this.$store.state.sceneList.length > 0"></scene-list>
    </div>
  </home-layout>
</template>

<script type="text/babel">
  /* eslint-disable */
  import HomeLayout from '../../../layouts/HomeLayout';
  import GuideList from '../components/GuideList';
  import SceneList from '../components/SceneList';


  export default {
    components: {
      HomeLayout,
      GuideList,
      SceneList,
    },
    methods: {
      
    },
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .site-header {
    background-color: rgba(255, 255, 255, .3);
    color: #fff;
    box-shadow: none;
  }
  .site-logo,
  .site-nav > a,
  .site-nav .user-info a {
    color: #fff;
    &:hover {
      color: #ffab10;
    }
  }
  .site-nav {
    color: #fff;
    .user-info {
      color: #ccc;
      a {
        color: #fff;
      }
    }
    .sep {
      color: #999;
    }
  }
  .site-main {
    margin-top: -45px;
  }
</style>

<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../../../scss/_mui.scss";
  
  .page-bn {
    position: relative;
    z-index: 1;
    width: 100%;
    height: 560px;
    background: #000 url("/static/images/u2.jpg") no-repeat 50% 0;
    background-size:cover;
    background-position:center;

  }
  @media screen and (max-width: 1400px){
    .page-bn {
      height: 300px;
    }
  }

  .page-main {
    padding-top: 24px;
    padding-bottom: 24px;
    .feature-list {
      width: 1220px;
      margin: 0 auto;
      padding: 0;
      list-style-type: none;
      text-align: center;
      li {
        float: left;
        width: 265px;
        height: 170px;
        margin: 0 10px;
        padding: 30px 10px 0;
        background-color: $white;
        transform-origin: 50% 50%;
        transition: transform $speedFast;
        @include setShadow(2);
        cursor: pointer;
        &:hover {
          transform: translate3d(0, -2px, 0);
        }
      }
      .icon {
        width: 60px;
        height: 60px;
        margin-bottom: 20px;
        background: url("/static/images/icons_home.png") no-repeat;
      }
      @for $i from 1 through 4 {
        .icon-0#{$i} { background-position: -60px * ($i - 1) 0; }
      }
      .title {
        margin: 0 0 5px;
        font-size: 18px;
        font-weight: 700;
      }
      .desc {
        margin: 0;
        color: $grayDark;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Homepage.vue?1e965438